import React from "react";
import { ITableV2Column } from "components/table-v2/table-v2";
import { DefaultHeaderCell } from "components/table-v2/header-cells";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { TMRIRadarNegotiatorRelationExtendedData } from "types/mri-radar.type";
import { MRIRadarNegotiatorSyncInput } from "./MRIRadarNegotiatorSyncInput";

export const syncMRIRadarNegotiatorTableColumnDef = (
  updateSyncPair: (relation: TMRIRadarNegotiatorRelationExtendedData) => void
): ITableV2Column<TMRIRadarNegotiatorRelationExtendedData>[] => {
  return [
    {
      accessor: "userName",
      Header: <DefaultHeaderCell>LeadPro user</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell textTransform={"capitalize"}>
          {row.userName}
        </DefaultRowCell>
      ),
    },
    {
      accessor: "mriNegotiatorEmail",
      excludeFromGlobalFilter: true,
      disableSortBy: true,
      Header: <DefaultHeaderCell>MRI login email</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <MRIRadarNegotiatorSyncInput record={row} onChange={updateSyncPair} />
        </DefaultRowCell>
      ),
    },
  ];
};
